/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "@jsq/ds/core";
import { useUpdateIraAccountMutation } from "../../graphql/supergraph.index";
import { MISSING_VALUE_PLACEHOLDER } from "../common/constants";
import { EntitySurveyPage } from "../EntitySurveyPage";
import { Question } from "../EntityTypeSurvey/types";
import { provideFullName } from "../ProfileTree/utils";
import { HybridCategorizationPageProps } from "./types";

export const HybridCategorizationPage: React.FC<HybridCategorizationPageProps> = ({
  profileId,
  caseResult,
  basePath,
}) => {
  const history = useHistory();
  const complianceCase = caseResult.data?.complianceCasesByObjectId[0];

  const getIsIraAnswer = () => {
    if (!complianceCase?.investingProfile?.metaData) {
      return "";
    }

    const metaData = complianceCase?.investingProfile?.metaData;

    if (!("is_ira_account" in metaData)) {
      return "";
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaData.is_ira_account ? "Yes" : "No";
  };
  const allProfiles = complianceCase?.profiles.concat([complianceCase.investingProfile]);
  const caseId = complianceCase?.id;

  const profile = allProfiles?.filter((p) => p?.id === profileId)[0];

  const [updateIraAccount] = useUpdateIraAccountMutation();

  if (!profile) {
    throw new Error("Profile not found");
  }
  const iraSingleQuestionList = [
    {
      id: "1",
      question: "Is this account an IRA or non-US retirement account?",
      answer: getIsIraAnswer(),
    },
  ] as Question[];
  const getProfileName = () => {
    // Get name in a non-standard way because we are not sure if the profile is an institution or individual
    // with this hybrid ('ira') account type
    const displayName = profile.legalName?.trim() ?? MISSING_VALUE_PLACEHOLDER;

    const fullName = provideFullName(profile);
    return displayName === MISSING_VALUE_PLACEHOLDER ? fullName : displayName;
  };
  return (
    <EntitySurveyPage
      questions={iraSingleQuestionList}
      entityName={getProfileName()}
      hideBackButton={true}
      onCompleted={async (values) => {
        const isIraAccount = !!values.updatedQuestions.find(
          (question) => question.answer === "Yes",
        );

        await updateIraAccount({
          variables: {
            profileId: profileId || 0,
            metaData: { is_ira_account: isIraAccount },
            caseId: caseId || 0,
          },
          refetchQueries: ["GetComplianceCasesByObjectId"],
          awaitRefetchQueries: true,
          onCompleted: () => {
            toast.success("Answer recorded successfully");
            history.push(`${basePath}`);
          },
          onError: () => {
            toast.error(`Error recording answer`);
          },
        });
      }}
      onBack={() => {
        history.goBack();
      }}
    />
  );
};
